// base
import React, { Component, useEffect } from "react";

// components
import {
  Layout,
  PageState,
  Search,
  Pager,
  ContentsBox,
  IsLoadingLayout,
  TopBalanceComponent,
  TransactionsComponent,
} from "../../components";
import ReactTooltip from "react-tooltip";
import { toFixed } from "../../../helper";

// assets
import "./txList.scss";
import {
  transactionListByTokenType,
  contractDetail,
  contractInTransactions25,
} from "../../../api";
import { connect } from "react-redux";
import abiDecoder from "abi-decoder";

const SEEDCONTRACT = "0xfe1d22e38830659ea6a8a520c7b49efe8ffedb04";

class TokenTransactionList extends Component {
  constructor(props) {
    super(props);

    this.state = this.initState(this.props.match.params.type);
  }

  initState = (type) => {
    return {
      pageNum: 1,
      pages: 1,
      pageSize: 25,
      txList: null,
      type: type ? type : "ARC20",
      abi: null,
      abiViewData: null,
    };
  };

  getContractTXList(type, pageNum) {
    if (type === "ARC20") {
      transactionListByTokenType(type, pageNum)
        .then((res) => {
          // contractInTransactions25(SEEDCONTRACT, pageNum).then((res) => {
          if (res.data) {
            this.setState({
              txList: res.data.list,
              transactionCnt: res.data.total,
              pageNum: res.data.pageNum,
              pages: res.data.pages,
            });
          } else {
            this.setState({ txList: [] });
          }
        })
        .catch((err) => {
          console.error(err);
          this.setState({ txList: [] });
        });

      // transactionListByTokenType(type, pageNum).then((res) => {
      //   if (res.data) {
      //     this.setState({
      //       txList: res.data.list,
      //       pages: res.data.pages,
      //       pageNum: res.data.pageNum,
      //     });
      //   }
      //   if (type == "ARC20") {
      //     // console.log("@@@");
      //     let fixTx = Promise.all(
      //       res.data.list.map((tx) => {
      //         let abi = this.getContract(tx.contract);
      //         // console.log("####");
      //         // console.log(tx);
      //         // console.log(abi);
      //         // if (abi) {
      //         //   try {
      //         //     abiDecoder.addABI(abi);
      //         //     tx.inputData = abiDecoder.decodeMethod(tx.input);
      //         //     // txs = transactions.map((tx) => {
      //         //     //   tx.inputData = abiDecoder.decodeMethod(tx.input);
      //         //     //   return tx;
      //         //     // });
      //         //     // console.log(tx.inputData);
      //         //     return tx;
      //         //   } catch (error) {
      //         //     console.warn(error);
      //         //   }
      //         // }
      //       })
      //     );
      //     console.log(fixTx);
      //   }
      // });
    } else if (type === "ARC721") {
      transactionListByTokenType(type, pageNum).then((res) => {
        if (res.data) {
          this.setState({
            txList: res.data.list,
            pages: res.data.pages,
            pageNum: res.data.pageNum,
          });
        }
      });
    }
  }

  movePage = (action) => {
    const { pageNum, pages } = this.state;

    if (action === "next" && pageNum < pages) {
      this.setState({ txList: null });
      this.getContractTXList(this.state.type, pageNum + 1);
    } else if (action === "prv" && pageNum > 1) {
      this.setState({ txList: null });
      this.getContractTXList(this.state.type, pageNum - 1);
    } else if (action === "first") {
      this.setState({ txList: null });
      this.getContractTXList(this.state.type, 1);
    } else if (action === "last") {
      this.setState({ txList: null });
      this.getContractTXList(this.state.type, pages);
    }
  };

  getContract = (address) => {
    contractDetail(address)
      .then((res) => {
        if (res.data) {
          let contract = res.data;
          let abi = contract.abi ? JSON.parse(contract.abi) : null;
          this.setState({ contract, abi });
        } else {
          this.props.history.push(`/`);
        }
      })
      .catch((err) => {
        this.props.history.push(`/`);
        console.error(err);
      });
  };

  componentDidMount() {
    const { type } = this.props.match.params
      ? this.props.match.params
      : "ARC20";
    if (type === "ARC20") {
      this.getContract(SEEDCONTRACT);
    }
    this.getContractTXList(type, 1);
  }

  componentDidUpdate(prevProps) {
    const { type } = this.props.match.params
      ? this.props.match.params
      : "ARC20";
    if (type !== prevProps.match.params.type) {
      if (type === "ARC20") {
        this.getContract(SEEDCONTRACT);
      }
      this.setState(this.initState(type));
      this.getContractTXList(type, 1);
    }
    ReactTooltip.rebuild();
  }

  render() {
    const { pageNum, pages, txList, type, abi } = this.state;
    return (
      <Layout>
        <main className="blocks_main">
          <div className="l-wrapper">
            <div className="page_upper">
              <Search />
              <PageState pageName={`${type} TransactionList`} />
            </div>
            <div className="blocks_contents_group">
              <div className="col blocks">
                <ContentsBox title={`${type} TransactionList`}>
                  {txList ? (
                    <>
                      <TransactionsComponent
                        transactions={this.state.txList}
                        totalBalance={this.state.totalBalance}
                        totalAccounts={this.state.totalAccounts}
                        pageNum={this.state.pageNum}
                        pageSize={this.state.pageSize}
                        contractTx={true}
                        type={type}
                        abi={abi}
                      />
                      <div className="blocks_pager">
                        <Pager
                          currentPage={pageNum}
                          totalnum={pages}
                          movepage={this.movePage}
                        />
                      </div>
                    </>
                  ) : (
                    <IsLoadingLayout isLoading={true} />
                  )}
                </ContentsBox>
              </div>
              <ReactTooltip />
            </div>
          </div>
        </main>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    network: state.appState.network,
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TokenTransactionList);
